import type { IconData } from '@stacksjs/iconify-core'

export const scissors: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.107 10.554L7.363 12.63a3.99 3.99 0 0 1-.192 4.89a4.004 4.004 0 0 1-5.635.492a3.99 3.99 0 0 1-.493-5.628a4.005 4.005 0 0 1 4.788-1.038L7.801 9L2.413 2.587a1 1 0 0 1 .123-1.407a1 1 0 0 1 1.409.123l5.162 6.144l5.161-6.144a1 1 0 0 1 1.41-.123a1 1 0 0 1 .123 1.407L10.412 9l1.97 2.345a4.005 4.005 0 0 1 4.788 1.038a3.99 3.99 0 0 1-.493 5.628a4.004 4.004 0 0 1-5.635-.492a3.99 3.99 0 0 1-.192-4.89zm-6.285 5.927a2 2 0 0 0 2.571-3.06a2 2 0 0 0-2.818.246c-.71.845-.6 2.105.247 2.814m12.57 0a1.996 1.996 0 0 0 .246-2.814a2 2 0 0 0-2.817-.246a1.996 1.996 0 0 0-.247 2.814c.71.845 1.972.955 2.818.246\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default scissors
